import { Injectable } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { MarkAsBrokenParams } from './mark-as-broken-params';
import { MarkAsBrokenComponent } from './mark-as-broken.component';

@Injectable({
  providedIn: 'root'
})
export class MarkAsBrokenServiceService {
  constructor(private modal: BsModalService) {}

  openMarkAsBrokenDialog(citationId: any, isFile: boolean, params: MarkAsBrokenParams, onConfirm: () => void) {
    this.modal.show(MarkAsBrokenComponent, {
      initialState: {
        citationId: citationId,
        isFile: isFile,
        params: params,
        confirm: onConfirm
      }
    });

    this.modal.onHide.subscribe(() => {
      const elementToFocus = document.querySelector('#viewOnlineReportBrokenLinkBtn');
      if (elementToFocus != null) {
        (elementToFocus as HTMLElement).focus();
      }
    });
  }
}
